import { IUploadFile } from "../services/document-management.service";
import { SortAttribute } from "../../core/models/sort.model";

export interface OnBaseProgramArea {
    id: number;
    name: string;
}

export interface OnBaseDocumentGroup {
    id: number;
    name: string;
    programAreaId?: number;

}export interface OnBaseMappedDocumentGroup extends OnBaseDocumentGroup{
    programAreaId?: number;
}

export interface OnBaseDocumentType {
    id: number;
    name: string;
    documentGroupName?: string;
}

export enum OnBaseProcessName {
    EjectLetter = "Eject Letter",
    EDiscovery = "e-Discovery",
    DataCorrection = "Data Correction",
    LandownerPassthrough = "Landowner Passthrough",
    StratigraphicApplication = "Stratigraphic Application",
    PostDrilling = "Post-Drilling",
	PaymentAdjustments = "Payment Adjustments",
	PermitRegeneration = "Permit Regeneration",
	PermitLookup = "Permit Lookup"
}

export interface OnBaseDocumentTypeProcessReference {
    id: number;
    processName: string;
    subProcessName?: OnBaseSubProcessName;
    onBaseDocumentTypeName: string;
    onBaseDocumentGroupName: string;
}

export interface OnBaseDocumentTypeProcessReferenceRequest {
    processName: string;
}

export enum OnBaseSubProcessName {
    ApplicationData = "Application Data",
    ApplicationNotes = "Application Notes",
    ContactNotes = "Contact Notes",
    OrganizationNotes = "Organization Notes",
    RequestDocument = "Request Document",
    WorkOrders = "Work Orders",

    InsuranceAndBondingAffidavit = "Insurance and Bonding Affidavit",
    PluggingApplication = "Plugging Application",
    ScopeOfWork = "Scope of Work",
    LocationMap = "Location Map",
    ApplicationPacketReceived = "Application Packet Received",
    PluggingPlan = "Plugging Plan",
    RestorationAgreement = "Restoration Agreement",
    LandownerPassthrough = "Landowner Passthrough",

    AerialPhotographyForUrbanArea = "Aerial Photography for Urban Area",
    AerialPhotographyWithContours = "Aerial Photography with Contours",
    AdditionalPertinentDocuments = "Additional Pertinent Documents",
    RestorationPlan = "Restoration Plan",
    PlatMapsPermitted = "Plat Maps - Permitted",
    UrbanAreaAffidavit = "Urban Area Affidavit",
    SpecialCondition2040Acre = "Special Condition - 20/40 Acre",
    SpecialConditionAnnualDisposal = "Special Condition - Annual Disposal",
    SpecialConditionAnnularDisposal = "Special Condition - Annular Disposal",
    SpecialConditionAshtabulaDevonianFluidRotary = "Special Condition - Ashtabula Devonian Fluid Rotary",
    SpecialConditionAshtabulaDevonianOriskany = "Special Condition - Ashtabula Devonian Oriskany",
    SpecialConditionEnhancedRecovery = "Special Condition - Enhanced Recovery",
    SpecialConditionConductorMineStringComboBasket = "Special Condition - Conductor Mine String Combo Basket",
    SpecialConditionDirectionalDrilling = "Special Condition - Directional Drilling",
    SpecialConditionFailureToMaintainInsuranceCoverage = "Special Condition - Failure to Maintain Insurance Coverage",
    SpecialConditionFluidRotaryLakePlainOriskany = "Special Condition - Fluid Rotary Lake Plain Oriskany",
    SpecialConditionHorizontalDrilling = "Special Condition - Horizontal Drilling",
    SpecialConditionHydrogenSulfide = "Special Condition - Hydrogen Sulfide",
    SpecialConditionIelSuperfund = "Special Condition - IEL Superfund",
    SpecialConditionKnoxUnconformity = "Special Condition - Knox Unconformity",
    SpecialConditionLakePlainsOriskany = "Special Condition - Lake Plains Oriskany",
    SpecialConditionLakePlainsUtica = "Special Condition - Lake Plains Utica",
    SpecialConditionsMineStringBasketVoid450 = "Special Conditions - Mine String Basket Void 450",
    SpecialConditionsMineStringBasketVoidGreater300 = "Special Conditions - Mine String Basket Void Greater 300",
    SpecialConditionMineStringBasketVoidLess300 = "Special Condition - Mine String Basket Void Less 300",
    SpecialConditionMunicipalWellheadProtectionClinton = "Special Condition - Municipal Wellhead Protection Clinton",
    SpecialConditionMunicipalWellheadProtectionQueenston = "Special Condition - Municipal Wellhead Protection Queenston",
    SpecialConditionNoPerforationZone = "Special Condition - No Perforation Zone",
    SpecialConditionNoiseMitigation = "Special Condition - Noise Mitigation",
    SpecialConditionOldWellUnknownStatus = "Special Condition - Old Well Unknown Status",
    SpecialConditionOther = "Special Condition - Other",
    SpecialConditionPrepermittingShale = "Special Condition - Prepermitting Shale",
    SpecialConditionPrepermittingUrban = "Special Condition - Prepermitting Urban",
    SpecialConditionRemovalOfFluid = "Special Condition - Removal of Fluid",
    SpecialConditionSeismicActivity = "Special Condition - Seismic Activity",
    SpecialConditionShallowGas = "Special Condition - Shallow Gas",
    SpecialConditionSsm1 = "Special Condition - SSM1",
    SpecialConditionSsm4 = "Special Condition - SSM4",
    SpecialConditionSwiw = "Special Condition - SWIW",
    SpecialConditionSurfaceCasingMineStringCombo = "Special Condition - Surface Casing Mine String Combo",
    SpecialConditionSurfaceCasingMineStringComboBasket = "Special Condition - Surface Casing Mine String Combo Basket",
    SpecialConditionThinGlacialTillQueenston = "Special Condition - Thin Glacial Till Queenston",
    SpecialConditionThinGlacialTillClinton = "Special Condition - Thin Glacial Till Clinton",
    SpecialConditionTrempealeau = "Special Condition - Trempealeau",
	SpecialConditionWellInAor = "Special Condition - Well in AOR",
	WellPermit = "Well Permit",

    BoreholeDeviationSurvey = "Borehole Deviation Survey",
    PlatMapsFinal = "Plat Maps Final",
    PlatMapsAsDrilled = "Plat Maps As Drilled",
    PlatMapsRevised = "Plat Maps Revised",
    RoyaltyInterestListing = "Royalty Interest Listing",
    ElectricLogs = "Electric Logs",
    PluggingReport = "Plugging Report",
    CementTickets = "Cement Tickets",
    CementJobLog = "Cement Job Log",
    SafetyDataSheets = "Safety Data Sheets",
    OtherCementData = "Other Cement Data",
    PRGraph = "P-R Graph",
    StimulationInvoice = "Stimulation Invoice",
    StimulationRecord = "Stimulation Record",
    StimulationLog = "Stimulation Log",
    SurfaceHoleAdditives = "Surface Hole Additives",
    WellStimAdditives = "Well Stim Additives"
}

export interface OnBaseKeyword {
    id: number;
    name: string;
    dataLength: number;
    dataType: string;
}

export interface OnBaseKeywordEntityMapping {
    entityId: string;
    entityFieldPath: string;
}

export interface OnBaseDropdownValue {
	value: string,
	isDefault: boolean
}

export interface OnBaseKeywordSimple extends OnBaseKeyword {
    allowMultiSelect: boolean;
	dropdownValues: OnBaseDropdownValue[];
    mappedEntities: OnBaseKeywordEntityMapping[];
}
export interface OnBaseMappedKeyword extends OnBaseKeywordSimple {
    documentGroupId: number;
    documentGroupName: string
    documentTypeId: number;
    documentTypeName: string
    isRequired: boolean;
}

export interface OnBaseKeywordMappingSearchSpec {
    keywordId?: number;
    keywordName?: string;
    documentGroupId?: number
    documentGroupName?: string
    documentTypeId?: number
    documentTypeName?: string
    isRequired?: boolean;
    entityId?: string;
}

export class OnBaseDocumentTypeSearchSpec {
    id?: number;
    name?: string;
    documentGroupId?: number;
    documentGroupName?: string;

    constructor() { }

    isValid(): boolean {
        return (this.id != null || this.documentGroupId != null || (this.name != null && this.name.length > 0) || (this.documentGroupName != null && this.documentGroupName.length > 0));
    }
}

export class OnBaseKeywordTypeSearchSpec {
    id?: number;
    name?: string;
    documentTypeId?: number;
    documentTypeName?: string;
    documentGroupId?: number;
    documentGroupName?: string;

    constructor() { }

    isValid(): boolean {
        return (this.id != null || (this.name != null && this.name.length > 0)
                || this.documentTypeId != null  || (this.documentTypeName != null && this.documentTypeName.length > 0)
                || this.documentGroupId != null  || (this.documentGroupName != null && this.documentGroupName.length > 0));
    }
}

export interface OnBaseKeywordValue {
    keywordTypeId: number;
    keywordTypeName: string;
    keywordValue: any;
}

export interface CommitProvisionedFileWithKeywordsRequest {
    provisionedFile: IUploadFile,
    documentTypeId: number,
    documentTypeName: string,
    keywordValues: OnBaseKeywordValue[]
}

export interface OnBaseQueryModel {
    documentTypeIds: number[];
    documentTypeNames: string[];
    matchAll?: boolean;
    maxResults: number;
    resultsPerPage: number;
    pageNumber: number;
    displayKeywordTypes: number[];
    fromDate?: Date;
    toDate?: Date;
    searchParameters: OnBaseKeywordQuery[];
    sort: SortAttribute;
    isAscending: boolean;
}

export enum KeywordRelation {
    And = "AND",
    Or = "OR"
}

export class OnBaseKeywordQuery {
    keywordTypeId: number;
    keywordTypeName: string;
    keywordValue: number | string | Date;
    relation: KeywordRelation = KeywordRelation.Or;
    operator: string;

    constructor(id: number, name: string, value: number | string | Date, operator: string) {
        this.keywordTypeId = id;
        this.keywordTypeName = name;
        this.keywordValue = value;
        this.operator = operator;
    }

    toString(): string {
        return `${this.keywordTypeName} ${this.operator} ${this.keywordValue}`;
    }
}

export function keywordEquals(a: OnBaseKeywordQuery, b: OnBaseKeywordQuery): boolean {
    return a.keywordTypeId === b.keywordTypeId && a.keywordValue === b.keywordValue && a.operator === b.operator;
}

export interface DocumentRecord {
    resultNumber: number;
    documentId: number;
    name: string;
    contentType: string;
    displayColumns: KeyValuePair[];
}

export interface QueryResult {
    totalRecords: number;
    records: DocumentRecord[];
}

export interface KeyValuePair {
    key: any;
    value: any;
}

export interface OnBaseDocumentDetails {
    id: number;
    name: string;
    createdBy: string;
    createdDate: Date;
    documentTypeId: number;
    documentTypeName: string;
    fileExtension: string;
    keywords: OnBaseKeywordValue[]
    mimeType: string;
    queueId?: string;
}

export function parseFileNameFromHeaders(headers: string): string {
    let parts = headers.split(';');
    let fileNamePart = parts.find(p => p.trim().toLocaleLowerCase().startsWith("filename"));
    if (fileNamePart == null) return "";
    let nameParts = fileNamePart.split('=');
    if (nameParts == null) return "";
    else if (nameParts.length === 1) return nameParts[0];
    else return nameParts[1].replace(/\"/gi, "");
}

export interface OnBaseUploadedFileLogSearchSpec {
    programArea: string;
    contactId: string;
    documentGroupName: string;
    documentTypeName: string;
    apiNumber: string;
    organizationId: string;
    organizationName: string;
    fromDate: Date;
    toDate: Date;
}

export interface OnBaseFileUploadLog {
    programArea: string;
    contactId: string;
    contactDisplayName: string;
    documentGroupName: string;
    documentTypeName: string;
    apiNumber: string;
    organizationId: string;
    organizationName: string;
    uploadedDocumentName: string;
    uploadTimeStamp: Date;
    onBaseFileUploadLogKeywords: OnBaseKeywordValue[];
    successfullySentToOnbase: boolean;
}

export interface BlobDownloadRequest {
    uri: string;
    contentType: string;
    fileName: string;
}

export interface QueuedDocumentRequest {
    documentId?: number;
    queuedDocumentId?: string;
}

export interface QueuedMessage {
    enqueuedTime: Date;
    content: string;
}

export class FileQueueKeyword  {
    keywordId: number;
    keywordName: string;
    keywordValue: any;
    fileIdentifier: string;
}

export class FileQueueQuery {
    documentTypeName?: string;
    endDate?: Date;
    fileName?: string;
    includePending: boolean = true;
    includeNeedingRequeued: boolean = true;
    includeCompleted: boolean = true;
    startDate?: Date;
}

export interface FileQueueEntry {
    identifier: string;
    programArea: string;
    documentType: string;
    documentGroup: string;
    fileName: string;
    apiNumber: string;
    organizationId: string;
    uploadedById: string;
    uploadedByName: string;
    documentId: string;
    uploadTimeStamp?: Date;
    onBaseDocumentId?: number;
    contentType: string;
    applicationNumber: string;
    keywords: FileQueueKeyword[];
    message?: QueuedMessage;
}